import * as v from "valibot";

import { rpcContract } from "../rpc";

export const getMutedCreatorsRpcContract = rpcContract({
  name: "get-muted-creators" as const,
  paramsSchema: v.object({}),
  resultSchema: v.object({
    mutedCreatorIds: v.array(v.string()),
  }),
});

export const muteCreatorRpcContract = rpcContract({
  name: "mute-creator" as const,
  paramsSchema: v.object({
    creatorId: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export const unmuteCreatorRpcContract = rpcContract({
  name: "unmute-creator" as const,
  paramsSchema: v.object({
    creatorId: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type GetMutedCreatorsParams = v.InferInput<typeof getMutedCreatorsRpcContract.paramsSchema>;
export type GetMutedCreatorsResult = v.InferOutput<typeof getMutedCreatorsRpcContract.resultSchema>;

export type MuteCreatorParams = v.InferInput<typeof muteCreatorRpcContract.paramsSchema>;
export type MuteCreatorResult = v.InferOutput<typeof muteCreatorRpcContract.resultSchema>;

export type UnmuteCreatorParams = v.InferInput<typeof unmuteCreatorRpcContract.paramsSchema>;
export type UnmuteCreatorResult = v.InferOutput<typeof unmuteCreatorRpcContract.resultSchema>;
